@if(status.success && successMessage) {
<p class="col-3"
   [sizeClass]="'SM: s2, XL: s1'">{{successMessage}}</p>
} @else {
<ng-form #form="ngForm">
    <div class="flex flex-top-x flex-top-l flex-column-s flex-column-m left">
        <form-mui-field class="block flex-grow"
                        [label]="'Email address' | translate">
            <input class="input _email"
                   type="email"
                   name="email"
                   validatePattern="email"
                   [required]="true"
                   [(ngModel)]="data.email"
                   (ngModelChange)="detectChanges()"
                   (keyup.enter)="submit()"
                   cy-subscribeMailInput>
        </form-mui-field>
        @if (canSubmit) {
        <button [buttonStyle]="'button'"
                class="m-t-2-s m-t-2-m m-l-4-x m-l-4-l"
                [status]="status"
                sl-button="subscribe"
                cy-subscribeButton
                (click)="submit()">
            <span class="no-wrap">{{buttonCopy || ('Sign up' | translate)}}</span>
        </button>
        }
    </div>
    <result class="m-t-1 left block"
            cy-subscribeStatusMessage
            [status]="status"
            [success]="successMessage"></result>
</ng-form>
}